function TdEditInfo(props) {

  // Define variables
  const editInfoFunction = props.editInfoFunction;
  const object = props.object;
  const role = object.role;


  // Screen components
  let bodyElement;
  if( role != 'Admin') {
    bodyElement = (
      <button
        onClick={() => editInfoFunction(object)}
        class='icon icon-edit'
        title='Edit info'
      />
    );
  }


  return(
    <td class='td-icon'>
      <>{bodyElement}</>
    </td>
  );
}

export default TdEditInfo;